module.exports = __webpack_public_path__ + "static/media/stories-3.761409e5.png";